import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LangContext";

export default function Ribbon() {
  const { t } = useLang();
  return (
    <div className="border-y border-[var(--gold)]/15 bg-[var(--bg-2)] py-6" data-testid="marquee-ribbon">
      <Marquee speed={38} gradient={false} autoFill>
        <span className="mx-4 flex items-center font-serif text-3xl italic text-[var(--gold)]/70 md:text-5xl">
          {t.marquee}
          <span className="mx-6 inline-block h-2 w-2 rotate-45 bg-[var(--gold)]/50" />
        </span>
      </Marquee>
    </div>
  );
}
